// extracted by mini-css-extract-plugin
export default {"rating":"bK-z","numberOfStars":"cK-z","count":"dK-z","barGraphSpacing":"eK-z","barGraph":"fK-z"};